import {CorrespondantDto} from "@resources/resources";
import {TranslateService} from "@ngx-translate/core";
import {Component} from "@angular/core";
import {CerbaAuthService, CerbaCookieService, CookieConstantes, CorrespondantStore, UserStore} from "@digicerba/common";
import {Router} from "@angular/router";

@Component({
  selector: 'cm-header',
  templateUrl: './header.component.html',
  host: {'class': 'header'}
})
export class HeaderComponent {

  correspondants: Array<CorrespondantDto> = [];
  selectedValue: CorrespondantDto = null;

  constructor(private cookieService: CerbaCookieService,
              private correspondantStore: CorrespondantStore,
              private translate: TranslateService,
              private router: Router,
              private cerbaAuthService: CerbaAuthService,
              private userStore: UserStore) {
  }

  ngOnInit() {
    this.correspondants = this.correspondantStore.getCorrespondants();
    this.selectedValue = this.correspondantStore.getCorrespondant();

    if (this.selectedValue) {
      let tags: any[] = this.selectedValue.tags;

      if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
        this.translate.use('en');
      } else if (tags.indexOf("fr") != -1 || tags.indexOf("fra") != -1) {
        this.translate.use('fr');
      } else {
        this.redirectToAccueil();
      }
    } else {
      this.redirectToAccueil();
    }
  }

  getDomain(sN) {
    let serverName = sN;
    let serverPaths = serverName.split('.');
    let parts = serverPaths.length;
    if (parts > 1) {
      serverName = serverPaths[parts - 2] + "." + serverPaths[parts - 1];
    }
    return serverName;
  }

  redirectToAccueil() {
    let domain = this.getDomain(window.location.hostname);
    window.location.href = window.location.protocol + '//www.' + domain;
  }

  onCorrespondantChange(newValue: CorrespondantDto) {
    this.selectedValue = newValue;
    this.correspondantStore.setCorrespondant(newValue);
    this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
    this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, this.correspondantStore.getCorrespondant().code);

    if (this.selectedValue) {
      let tags: any[] = this.selectedValue.tags;

      if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
        this.translate.use('en');
      }
      else {
        this.translate.use('fr');
      }
    } else {
      this.translate.use('fr');
    }

    window.location.reload(true);
  }

  isTelechargements() {
    return this.router.url.indexOf("/catalogue-telecharger") >= 0;
  }

  isHistorique() {
    return this.router.url.indexOf("/historique-modifications") >= 0;
  }

  isCatalogue() {
    return this.router.url.indexOf("/catalogue-examens") >= 0;
  }

  isSpecific() {
    return this.isTelechargements() || this.isHistorique() || this.isCatalogue();
  }

  isGuest(): boolean {
    let role = this.userStore.getUser().role;
    return role == "INVITE";
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts